import {
  Clause8,
  CustomerComplaintList,
  CustomerReturnList,
  CustomerReturnAndReworkList,
  ListOfDefects,
  QualityAlertHome,
  CustomerConcernDashboardTabs,
} from '../../pages/clause8Page';

// main route of clause 10

export const clause8 = [
  {
    path: 'clause8',
    element: <Clause8 />,
  },
  // {
  //   path: 'qualityAlert',
  //   element: <QualityAlertHome />,
  // },
  {
    path: 'defect_list',
    element: <ListOfDefects />,
  },
  {
    path: 'CustomerComplaintRegister',
    element: <CustomerComplaintList />,
  },
  {
    path: 'CustomerReturnRegister',
    element: <CustomerReturnList />,
  },
  {
    path: 'CustomerReturnAndReworkRegister',
    element: <CustomerReturnAndReworkList />,
  },
  {
    path: 'customerConcernDashboard',
    element: <CustomerConcernDashboardTabs />,
  },
];
